import { motion } from 'framer-motion'

interface ButtonProps {
  children: React.ReactNode
  variant?: 'primary' | 'secondary' | 'ghost' | 'outline'
  size?: 'sm' | 'md' | 'lg'
  href?: string
  onClick?: () => void
  className?: string
}

const variants = {
  primary:
    'bg-primary text-white hover:bg-primary-dark',
  secondary:
    'bg-navy-900 text-white hover:bg-navy-800',
  ghost:
    'bg-white/[0.08] text-white/90 border border-white/[0.12] hover:bg-white/[0.12]',
  outline:
    'bg-white text-navy-700 border border-navy-200 hover:text-orange-500 hover:border-orange-300 hover:bg-orange-50',
}

const sizes = {
  sm: 'px-4 py-2 text-[13px]',
  md: 'px-5 py-2.5 text-[13px]',
  lg: 'px-7 py-3 text-sm',
}

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  onClick,
  className = '',
}: ButtonProps) {
  const classes = `inline-flex items-center justify-center font-medium rounded-full transition-all duration-200 cursor-pointer ${variants[variant]} ${sizes[size]} ${className}`

  if (href) {
    return (
      <motion.a
        href={href}
        className={classes}
        whileTap={{ scale: 0.97 }}
      >
        {children}
      </motion.a>
    )
  }

  return (
    <motion.button
      onClick={onClick}
      className={classes}
      whileTap={{ scale: 0.97 }}
    >
      {children}
    </motion.button>
  )
}
